var map = {
	"./App/About.vue": [
		3099,
		5363,
		3099
	],
	"./App/Base.vue": [
		51905,
		8181,
		1905,
		1785
	],
	"./App/Company.vue": [
		2732,
		2732,
		9215
	],
	"./App/Index.vue": [
		85214,
		5214
	],
	"./App/InvestorsPage.vue": [
		68186,
		5363,
		8186
	],
	"./App/News.vue": [
		7724,
		6197,
		7724,
		7370
	],
	"./App/PrivacyPolicy.vue": [
		93493,
		5363,
		3493,
		9939
	],
	"./App/Register.vue": [
		8036,
		9714,
		8468,
		8036,
		4612
	],
	"./App/Search.vue": [
		10535,
		535
	],
	"./App/SetPassword.vue": [
		52341,
		9466,
		2341
	],
	"./App/Videos.vue": [
		46769,
		6197,
		6769,
		6044
	],
	"./App/VideosSearch.vue": [
		52618,
		2618,
		3278
	]
};
function webpackAsyncContext(req) {
	if(!__webpack_require__.o(map, req)) {
		return Promise.resolve().then(function() {
			var e = new Error("Cannot find module '" + req + "'");
			e.code = 'MODULE_NOT_FOUND';
			throw e;
		});
	}

	var ids = map[req], id = ids[0];
	return Promise.all(ids.slice(1).map(__webpack_require__.e)).then(function() {
		return __webpack_require__(id);
	});
}
webpackAsyncContext.keys = function() { return Object.keys(map); };
webpackAsyncContext.id = 94235;
module.exports = webpackAsyncContext;